var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1538_7679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9533 11.1665L16.5 14.6198L13.0466 11.1665L11.1666 13.0465L14.62 16.4998L11.1666 19.9532L13.0466 21.8332L16.5 18.3798L19.9533 21.8332L21.8333 19.9532L18.38 16.4998L21.8333 13.0465L19.9533 11.1665ZM16.5 3.1665C9.12663 3.1665 3.16663 9.1265 3.16663 16.4998C3.16663 23.8732 9.12663 29.8332 16.5 29.8332C23.8733 29.8332 29.8333 23.8732 29.8333 16.4998C29.8333 9.1265 23.8733 3.1665 16.5 3.1665ZM16.5 27.1665C10.62 27.1665 5.83329 22.3798 5.83329 16.4998C5.83329 10.6198 10.62 5.83317 16.5 5.83317C22.38 5.83317 27.1666 10.6198 27.1666 16.4998C27.1666 22.3798 22.38 27.1665 16.5 27.1665Z",
    fill: "#133D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1538_7679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ddec5bf88107a5de9cbc1514b218ceb1.svg";
export { ForwardRef as ReactComponent };